import React from 'react';
import classes from './style.module.scss';

export default function Loading() {
  return (
    <div className={classes.container}>
      <img src="/assets/loader.gif" alt="" />
    </div>
  );
}
